import FollowedProperty from './followed-property';
export default FollowedProperty;